import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, createSelector,  } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ContrareciboList } from "./contrarecibos";
import { ViajesRevisionList } from "./viajes";
import { REPList } from "./reps";

const tabs = ["facturas", "reps", "viajes"];

interface Props {
    match: match<{ tab: "facturas" | "reps" | "viajes" }>
}

export class CobranzaComponent extends React.PureComponent<Props> {
    onRegresar = () => {
        history.go("../");
    }

    tab = (x: Props) => x.match.params.tab;
    tabIndex = createSelector(this.tab, tab=> tab ? tabs.indexOf(tab) : 0 )

    onTabChange = (x: number) => {
        const tab = this.tab(this.props);
        history.go( (tab ? "../" : "./") + tabs[x]);
    }

    render() {
        return (
            <div>
                <kea.Tab
                    value={this.tabIndex(this.props)}
                    onChange={this.onTabChange}
                    items={[
                        {
                            title: "Facturas de crédito",
                            iconClass: fa("file-o"),
                            body: <ContrareciboList  />
                        }, {
                            title: "REPs",
                            iconClass: fa("money"),
                            body: <REPList />
                        }, {
                            title: "Viajes de cobranza",
                            iconClass: fa("exchange"),
                            body: <ViajesRevisionList cookieKey="viajesRevisionList" />
                        }
                    ]}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/edit.tsx